<template>
  <LayoutGradient :title="$t('vns.permissoes.form.titulo_pagina')" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <h3>{{ vns.name }}</h3>
      <b-form-checkbox
          v-for="(permission, permIndex) in permissions"
          :key="permIndex"
          value="me"
          v-model="permissionsForm[permIndex]"
          :value="permission.id"
      >{{ permission.nome }}
      </b-form-checkbox>
      <b-button type="submit" variant="success" @click="(evt) => update(evt)" class="mt-4">
        <i class="fas fa-save"/> {{ $t('vns.permissoes.form.botao_salvar') }}
      </b-button>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import PermissionRepository from '@/repositories/vns/PermissionRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "UpdatePermission",
  components: {
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      vns: 'vns/current',
      permissions: 'vns/allPermissions',
      isLoading: 'vns/isLoading'
    })
  },
  data() {
    return {
      permissionsForm: []
    }
  },
  methods: {
    ...mapActions([
      'vns/listOne',
      'vns/listAllPermissions'
    ]),
    update(evt) {
      evt.preventDefault()
      const permissionsSanitized = this.permissionsForm.filter((permission) => {
        return permission;
      })
      PermissionRepository.put(
          this.$route.params.id,
          {
            vns_id: this.$route.params.id,
            permissions: permissionsSanitized
          }
      ).then(() => {
        this.$snotify.success(this.$t('vns.permissoes.form.update.success'))
      }).catch(error => {
        this.$snotify.error(this.$t('vns.permissoes.form.update.error'))
        if (error.response.status === 422) {
          PermissionRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    await this['vns/listOne'](this.$route.params.id)
    await this['vns/listAllPermissions']()
    this.permissions.map((permission, index) => {
      const arrayTeste = this.vns.permissions.filter((vnsPermission) => {
        return permission.id === vnsPermission.id
      })
      if (arrayTeste.length > 0) {
        this.permissionsForm[index] = permission.id
      }
    })
    this.$forceUpdate()
  }
}
</script>

<style scoped>
</style>
